import { z } from 'zod';

export const MonitoringConfigSchema = z.object({
  dsn: z.string().optional().default(''), // Optional for local development without Sentry
  environment: z.enum(['local', 'development', 'production']),
  enableTracing: z.boolean().default(true),
  sampleRate: z.number().min(0).max(1).default(1.0),
  debug: z.boolean().default(false),
  logLevel: z.enum(['error', 'warn', 'info', 'debug']).default('info'),
  tracingOrigins: z.array(z.string()).default(['localhost', '127.0.0.1']),
  enableSessionReplay: z.boolean().default(false),
  replaysSessionSampleRate: z.number().min(0).max(1).default(0), // % of sessions to record
  replaysOnErrorSampleRate: z.number().min(0).max(1).default(1.0), // % of error sessions to record
});

export type MonitoringConfig = z.infer<typeof MonitoringConfigSchema>;
